import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, type Reponse } from "../../shared/api/client";
import type { DefinitionGeozone, Geozone } from "../../shared/api/types";

export function useZones() {
  return useQuery({
    queryKey: ["zones"],
    queryFn: () => api.lire<Geozone[]>("/v1/zones"),
    // Le référentiel de géozones change rarement — création par un administrateur, pas au fil de
    // l'eau — une fraîcheur longue évite de le relire à chaque écran qui en a besoin.
    staleTime: 5 * 60_000,
  });
}

function invalider(client: ReturnType<typeof useQueryClient>) {
  void client.invalidateQueries({ queryKey: ["zones"] });
}

export function useCreerZone() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (corps: DefinitionGeozone): Promise<Reponse<Geozone>> =>
      api.creer<Geozone>("/v1/zones", corps),
    onSuccess: () => invalider(client),
  });
}

export function useRemplacerZone() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({
      zoneId,
      corps,
    }: {
      zoneId: string;
      corps: DefinitionGeozone;
    }): Promise<Reponse<Geozone>> =>
      api.remplacer<Geozone>(`/v1/zones/${encodeURIComponent(zoneId)}`, corps),
    onSuccess: () => invalider(client),
  });
}

export function useDesactiverZone() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (zoneId: string): Promise<Reponse<Geozone>> =>
      api.supprimer<Geozone>(`/v1/zones/${encodeURIComponent(zoneId)}`),
    onSuccess: () => invalider(client),
  });
}
